import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useFeatureAccess, usePermissions } from '@/hooks/usePermissions';
import type { EntityTypeName } from '@/lib/crm/core/types';
import { getEntityTypeConfig } from '@/lib/crm/record/registry/entityTypeRegistry';

// Four gates, each for a different reason:
//  - the flag, because the builder is still being built;
//  - the chat feature, because restricted seats hit the paywall on builder/chat routes;
//  - the capability, because only automation-kind types have a builder;
//  - write permission, because `ahoy_default` is read-only on those types,
//    so offering a non-admin an Edit action leads to a guaranteed rejection.
export function useCanEditInBuilder(entityTypeName: EntityTypeName): boolean {
  const isBuilderModeEnabled = useFeatureFlag('builder_mode');
  const { hasFeature } = useFeatureAccess();
  const { hasPermission } = usePermissions();
  return (
    isBuilderModeEnabled &&
    hasFeature('chat') &&
    Boolean(getEntityTypeConfig(entityTypeName).supportsBuilderMode) &&
    hasPermission(entityTypeName, 'ahoy_property_updated')
  );
}
